/* Diálogos e cards do jogo: regras da Máfia, ficha dos serviços, escudos,
   procurados, rixas, regras dos rankings e avisos do Império.
   Chaves capturadas direto da tela renderizada (nada de palpite). */
export const OIL_DICT_RULES = {
  'Carregando…': { zh: '載入中…', en: 'Loading…' },
  'Oil Tycoon': { zh: 'Oil Tycoon', en: 'Oil Tycoon' },
  'pular tutorial': { zh: '跳過教學', en: 'skip tutorial' },
  '. Quanto maior o nível, mais petróleo jorra!': { zh: '。等級越高，石油噴得越多！', en: '. The higher the level, the more oil gushes!' },
  'Sabotagem da Refinaria': { zh: '煉油廠破壞', en: 'Refinery Sabotage' },
  'Cartão 1': { zh: '卡片 1', en: 'Card 1' },
  'Cartão 2': { zh: '卡片 2', en: 'Card 2' },
  'cartaz 1': { zh: '海報 1', en: 'poster 1' },
  'cartaz 2': { zh: '海報 2', en: 'poster 2' },
  'cartaz 3': { zh: '海報 3', en: 'poster 3' },
  'Informações sobre Espionagem Industrial': { zh: '商業間諜的說明', en: 'About Industrial Espionage' },
  'Informações sobre Interceptação de Carga': { zh: '貨物攔截的說明', en: 'About Cargo Interception' },
  'Informações sobre Vazamento no Oleoduto': { zh: '油管洩漏的說明', en: 'About Pipeline Leak' },
  'Informações sobre Sabotagem da Refinaria': { zh: '煉油廠破壞的說明', en: 'About Refinery Sabotage' },
  'Informações sobre Incidente na Plataforma': { zh: '平台事故的說明', en: 'About Platform Incident' },
  'Informações sobre Manipulação Clandestina': { zh: '地下操盤的說明', en: 'About Clandestine Manipulation' },
  'Informações sobre Assalto ao Cofre da Bolsa FOX': { zh: 'FOX 交易所金庫大劫案的說明', en: 'About the FOX Exchange Vault Heist' },
  'LIBERA EM --:--:--': { zh: '解鎖倒數 --:--:--', en: 'UNLOCKS IN --:--:--' },
  'OPS HOJE': { zh: '今日行動', en: 'OPS TODAY' },
  'EU FIZ (0)': { zh: '我出手（0）', en: 'I DID (0)' },
  'EU SOFRI (0)': { zh: '我被打（0）', en: 'I TOOK (0)' },
  'Todos os procurados ·': { zh: '所有通緝犯 ·', en: 'All wanted ·' },
  'de respeito': { zh: '聲望', en: 'respect' },
  'de Respeito': { zh: '聲望', en: 'Respect' },
  'moedas': { zh: '金幣', en: 'coins' },
  'moedas pretas': { zh: 'Black Coins', en: 'Black Coins' },
  '+30 no sucesso': { zh: '成功 +30', en: '+30 on success' },
  'Suas gotas:': { zh: '你的油滴：', en: 'Your drops:' },
  'Nenhum barril envasado. Extraia e envase! 🛢️': { zh: '還沒有裝好的油桶。去開採並裝桶吧！🛢️', en: 'No barrels bottled yet. Extract and bottle! 🛢️' },
  'usina': { zh: '鑽油塔', en: 'rig' },
  'envasadora': { zh: '裝桶廠', en: 'bottling plant' },
  'CONSTRUIR': { zh: '建造', en: 'BUILD' },
  'LV.': { zh: 'LV.', en: 'LV.' },
  'ENVASADORA LV.': { zh: '裝桶廠 LV.', en: 'BOTTLING PLANT LV.' },
  'PRIMEIRO': { zh: '先', en: 'FIRST' },
  '🔒 COMPRE A USINA LV.': { zh: '🔒 請先購買鑽油塔 LV.', en: '🔒 BUY RIG LV.' },

  // Regras da Máfia
  ': a parte suja da Bolsa do Petróleo. Aqui os magnatas contratam serviços por baixo do pano para queimar o FOX Dólar dos rivais, comprar proteção e construir Respeito nas ruas. Todo o dinheiro desta aba é do jogo — nada aqui mexe no seu saldo real de moedas.': {
    zh: '：石油交易所最黑暗的一面。大亨們在這裡私下雇人燒掉對手的 FOX Dólar、買下防護，並在街頭累積聲望。這個頁面的所有金錢都屬於遊戲 — 不會動到你真實的金幣餘額。',
    en: ': the dirty side of the Oil Exchange. Here tycoons hire services under the table to burn rivals\u2019 FOX Dólar, buy protection and build Respect on the streets. All money in this tab is game money — nothing here touches your real coin balance.' },
  'queimado': { zh: '燒掉', en: 'burned' },
  'queimam': { zh: '燒掉', en: 'burn' },
  ', nunca transferido para o atacante.': { zh: '，絕不會轉給攻擊者。', en: ', never transferred to the attacker.' },
  ', nunca vai para o atacante.': { zh: '，絕不會進攻擊者的口袋。', en: ', it never goes to the attacker.' },
  'do alvo': { zh: '目標的', en: "the target's" },
  'do alvo e o': { zh: '目標的，而', en: "of the target and the" },
  ', limitada a': { zh: '，上限為', en: ', limited to' },
  'por golpe.': { zh: '每次打擊。', en: 'per hit.' },
  'por golpe': { zh: '每次打擊', en: 'per hit' },
  'amassa a': { zh: '損壞', en: 'dents the' },
  'naquele nível até o dono': { zh: '該等級停擺，直到擁有者', en: 'at that level until the owner' },
  'pagar o reparo': { zh: '付費修復', en: 'pays the repair' },
  '. Reparo integral custa': { zh: '。完整修復費用為', en: '. A full repair costs' },
  '% do preço do nível': { zh: '% 的該等級價格', en: '% of the level price' },
  'pontos de dano em instalação por alvo por dia': { zh: '點設施傷害（每個目標每天）', en: 'facility damage points per target per day' },
  'qualquer império do': { zh: '任何帝國：', en: 'any empire in the' },
  'que ainda tenha império de sobra — busque por apelido ou KAKO ID, ou desça a lista com': {
    zh: '只要對方還有帝國可打 — 用暱稱或 KAKO ID 搜尋，或用以下方式瀏覽清單：',
    en: 'that still has an empire left — search by nickname or KAKO ID, or scroll the list with' },
  'cada jogador ganha no máximo': { zh: '每位玩家最多獲得', en: 'each player earns at most' },
  '. Depois disso os serviços continuam funcionando (dano, roubo de carga e espionagem), mas': {
    zh: '。之後服務仍可使用（傷害、劫貨與間諜），但是',
    en: '. After that the services keep working (damage, cargo heist and espionage), but' },
  'Você pode contratar até': { zh: '你每天最多可以雇用', en: 'You can hire up to' },
  'operações ofensivas por dia': { zh: '次攻擊行動', en: 'offensive operations per day' },
  '(o contador zera à meia-noite). Espionagens são ilimitadas.': { zh: '（計數在午夜歸零）。間諜行動無限制。', en: '(the counter resets at midnight). Espionage is unlimited.' },
  'No': { zh: '對', en: 'On the' },
  'mesmo alvo': { zh: '同一個目標', en: 'same target' },
  'você pode bater até': { zh: '你最多可以打', en: 'you can hit up to' },
  'x por dia': { zh: '次／天', en: 'x per day' },
  'sempre respeitando a imunidade dele entre um golpe e outro — e o Respeito cai a cada repetida (2º golpe metade, 3º zero).': {
    zh: '每次打擊之間仍須等他的免疫結束 — 而且重複打擊的聲望會遞減（第 2 次一半，第 3 次為零）。',
    en: 'always respecting his immunity between hits — and Respect drops with each repeat (2nd hit half, 3rd zero).' },
  'quem te acertou pode ser cobrado na hora pela aba': { zh: '打中你的人可以馬上在這個頁面被討回來：', en: 'whoever hit you can be charged right away from the tab' },
  'Quem acabou de tomar um golpe fica': { zh: '剛剛被打中的人會有', en: 'Whoever just took a hit becomes' },
  'h imune': { zh: '小時免疫', en: 'h immune' },
  'Novato tem': { zh: '新手擁有', en: 'A rookie has' },
  'h de proteção': { zh: '小時保護', en: 'h of protection' },
  'ao entrar na Season, e': { zh: '進入賽季時，而', en: 'when joining the Season, and' },
  '% do próprio FOX Dólar por dia': { zh: '% 的自有 FOX Dólar（每天）', en: '% of his own FOX Dólar per day' },
  'somando todos os ataques recebidos.': { zh: '，所有受到的攻擊合計。', en: 'adding up all attacks taken.' },
  'Nas últimas': { zh: '在最後', en: 'In the last' },
  'h da Season': { zh: '小時的賽季', en: 'h of the Season' },
  'entra a': { zh: '進入', en: 'the' },
  'Escudo de Ouro': { zh: '黃金護盾', en: 'Gold Shield' },
  'Escudo de Prata': { zh: '白銀護盾', en: 'Silver Shield' },
  'Escudo de Bronze': { zh: '青銅護盾', en: 'Bronze Shield' },
  'dos golpes · custa': { zh: '的打擊 · 花費', en: 'of the hits · costs' },
  'escudo mais forte entra na frente': { zh: '最強的護盾優先擋下', en: 'the strongest shield goes first' },
  'mais forte entra na frente': { zh: '最強的優先擋下', en: 'the strongest goes first' },
  '. (O Assalto ao Cofre paga mais: +120 e +70.)': { zh: '。（金庫大劫案給更多：+120 與 +70。）', en: '. (The Vault Heist pays more: +120 and +70.)' },
  'Bater sempre no mesmo alvo rende cada vez menos: o 1º golpe do dia nele paga': {
    zh: '一直打同一個目標會越來越沒用：當天第 1 次打擊給',
    en: 'Hitting the same target over and over pays less each time: the 1st hit of the day gives' },
  'cheio': { zh: '全額', en: 'full' },
  'metade': { zh: '一半', en: 'half' },
  'nada': { zh: '沒有', en: 'nothing' },
  'na parede.': { zh: '貼在牆上。', en: 'on the wall.' },
  'º lugar —': { zh: '名 —', en: 'place —' },
  'te acerta': { zh: '打中你', en: 'hits you' },
  'é o histórico completo: tudo o que você contratou (inclusive falhas e espionagens) e tudo o que chegou em você — com resultado, dano, Respeito e custo. É lá que fica o botão de': {
    zh: '是完整的紀錄：你雇用過的一切（包含失敗與間諜）以及所有打到你身上的事 — 含結果、傷害、聲望與花費。復仇按鈕就在那裡：',
    en: 'is the full history: everything you hired (including failures and espionage) and everything that landed on you — with result, damage, Respect and cost. The revenge button lives there:' },
  'fracassou': { zh: '失敗', en: 'failed' },
  'bronze': { zh: '青銅', en: 'bronze' },
  'prata': { zh: '白銀', en: 'silver' },
  'ouro': { zh: '黃金', en: 'gold' },
  '% bloqueio': { zh: '% 攔阻', en: '% block' },
  'garantida: 100%': { zh: '保證：100%', en: 'guaranteed: 100%' },

  // Ficha dos serviços
  'Um contador subornado abre os livros do alvo numa mesa de sinuca nos fundos do porto. Ninguém quebra nada — você só descobre onde o dinheiro dele dorme.': {
    zh: '一名被收買的會計在港口後方的撞球檯上翻開目標的帳本。沒有人砸壞任何東西 — 你只是查出他的錢藏在哪。',
    en: 'A bribed accountant opens the target books on a pool table behind the docks. Nobody breaks anything — you just find out where his money sleeps.' },
  '— seus informantes voltam com o dossiê ou voltam de mãos vazias.': { zh: '— 你的線人要嘛帶回情報，要嘛空手而回。', en: '— your informants either bring the dossier or come back empty-handed.' },
  '— pago na contratação, mesmo que a operação falhe.': { zh: '— 雇用時就付款，即使行動失敗也一樣。', en: '— paid on hiring, even if the operation fails.' },
  'Sucesso: dossiê completo do alvo na tela': { zh: '成功：目標的完整情報顯示在畫面上', en: 'Success: the full target dossier on screen' },
  '(o Top 3 ganha cartaz na parede e prêmio em moedas no fim da Season).': { zh: '（前 3 名可獲得通緝海報，並在賽季結束時拿到金幣獎勵）。', en: '(the Top 3 gets a poster on the wall and a coin prize at the end of the Season).' },
  'Dois caminhões-tanque saem da refinaria do alvo e nunca chegam ao porto. A carga desaparece nas docas antes do amanhecer e ninguém viu nada.': {
    zh: '兩台油罐車從目標的煉油廠出發，卻從未抵達港口。貨物在黎明前於碼頭消失，沒有人看到任何事。',
    en: "Two tankers leave the target's refinery and never reach the port. The cargo vanishes at the docks before dawn and nobody saw a thing." },
  'Um engenheiro comprado troca a peça errada de propósito. A refinaria do alvo para no meio do turno e o barril fica encalhado no pátio.': {
    zh: '被收買的工程師故意換錯零件。目標的煉油廠在班中停擺，油桶卡在廠區。',
    en: 'A bought engineer swaps the wrong part on purpose. The target refinery stops mid-shift and the barrel is stuck in the yard.' },
  'O serviço mais caro da Terra dos Mafiosos: entrar no cofre da Bolsa FOX e queimar a papelada do alvo. Poucos tentam, menos ainda voltam para contar.': {
    zh: '黑幫之地最貴的服務：闖進 FOX 交易所的金庫，燒掉目標的帳冊。很少人敢試，回來說故事的更少。',
    en: 'The most expensive service on the Mobster Turf: break into the FOX Exchange vault and burn the target paperwork. Few try, fewer come back to tell it.' },
  ', com teto de': { zh: '，上限為', en: ', capped at' },
  '. Se a operação fracassar você perde só o pagamento do serviço — e o alvo nem fica sabendo.': {
    zh: '。行動失敗時你只損失服務費用 — 目標甚至不會知道。',
    en: '. If the operation fails you only lose the service payment — and the target never knows.' },
  '(Ouro bloqueia 100%, Prata 60%, Bronze 30%) e é': { zh: '（黃金擋 100%、白銀 60%、青銅 30%），並且', en: '(Gold blocks 100%, Silver 60%, Bronze 30%) and it is' },
  'a novos golpes.': { zh: '，可抵擋新的打擊。', en: 'to new hits.' },
  'acertando, você leva': { zh: '命中時，你可以拿走', en: 'on a hit, you take' },
  '% dos barris prontos': { zh: '% 已裝好的油桶', en: '% of the finished barrels' },
  'do galpão dele': { zh: '從他的倉庫', en: 'from his warehouse' },
  '(teto de': { zh: '（上限', en: '(cap of' },
  'barris por golpe': { zh: '桶／次打擊', en: 'barrels per hit' },
  'começando pelos de': { zh: '從以下開始：', en: 'starting from the' },
  '. Os barris entram no seu galpão e podem ser vendidos.': { zh: '。這些油桶會進你的倉庫，可以賣出。', en: '. The barrels go into your warehouse and can be sold.' },
  'CARGA NOBRE (': { zh: '高級貨（', en: 'PREMIUM CARGO (' },
  'o caminhão estava com o melhor — a ordem inverte e o roubo começa pelos': {
    zh: '卡車上載的是最好的貨 — 順序反過來，先搶走',
    en: 'the truck was carrying the best — the order flips and the heist starts with the' },
  'Se o galpão dele estiver vazio, o caminhão levava só o bruto:': { zh: '如果他的倉庫是空的，卡車上只有原油：', en: 'If his warehouse is empty, the truck only carried crude:' },
  '% das gotas': { zh: '% 的油滴', en: '% of the drops' },
  'dele': { zh: '他的', en: 'his' },
  'barris por alvo por dia': { zh: '桶（每個目標每天）', en: 'barrels per target per day' },
  'nenhum barril e nenhuma gota saem': { zh: '不會再有油桶或油滴流出', en: 'no barrel and no drop leaves' },
  'das suas': { zh: '你的', en: 'of your' },
  'operações ofensivas do dia. No mesmo alvo você pode bater até': {
    zh: '當天的攻擊行動。對同一個目標你最多可以打',
    en: 'daily offensive operations. On the same target you can hit up to' },
  'e o prejuízo do alvo no seu histórico de Rixas.': { zh: '，以及目標的損失都會記在你的恩怨紀錄裡。', en: "and the target's loss in your Feuds history." },
  'pela ousadia — e ele perde o escudo de qualquer forma.': { zh: '作為膽識的回報 — 而他的護盾無論如何都會沒了。', en: 'for the nerve — and he loses the shield anyway.' },
  'Nenhum alvo pode perder mais de': { zh: '任何目標最多只能損失', en: 'No target can lose more than' },
  '% do FOX Dólar dele por dia': { zh: '% 的自有 FOX Dólar（每天）', en: '% of his FOX Dólar per day' },
  'zero': { zh: '零', en: 'zero' },
  '. Teto de': { zh: '。上限', en: '. Cap of' },
  'SABOTAGEM PESADA': { zh: '重度破壞', en: 'HEAVY SABOTAGE' },
  'acertando, a': { zh: '命中時，', en: 'on a hit, the' },
  'dele perde': { zh: '會損失', en: 'loses' },
  'de integridade': { zh: '完整度', en: 'of integrity' },
  'que ele tem.': { zh: '（他所擁有的）。', en: 'that he owns.' },
  ': ele não': { zh: '：他無法', en: ': he cannot' },
  'extrai': { zh: '開採', en: 'extract' },
  'naquele nível até': { zh: '該等級，直到', en: 'at that level until' },
  '. Três acertos quebram.': { zh: '。三次命中就壞掉。', en: '. Three hits break it.' },

  // Regras dos rankings
  'Regras dos Magnatas': { zh: '大亨規則', en: 'Tycoons Rules' },
  'Regras dos Corretores': { zh: '經紀人規則', en: 'Brokers Rules' },
  'vender barris': { zh: '賣出油桶', en: 'selling barrels' },
  ') — sobe a cada recarga do evento.': { zh: '）— 活動中每筆充值都讓它上升。', en: ') — it rises with every top-up in the event.' },
  'fim': { zh: '結束', en: 'end' },
  'afiliados': { zh: '推廣夥伴', en: 'affiliates' },
  'pelo seu link de afiliado': { zh: '透過你的推廣連結', en: 'through your affiliate link' },
  'moedas vendidas': { zh: '售出的金幣', en: 'coins sold' },
  'para o cliente jogar,': { zh: '給客戶遊玩，', en: 'for the customer to play,' },
  'para os rankings e': { zh: '給排行榜，以及', en: 'for the rankings and' },
  'para o afiliado que trouxe a venda.': { zh: '給帶來這筆銷售的推廣夥伴。', en: 'for the affiliate who brought the sale.' },
  // Avisos, rixas e execução
  'Beleza': { zh: '好的', en: 'Got it' },
  'Entendi': { zh: '我知道了', en: 'Understood' },
  'ESCOLHA UM ALVO': { zh: '請選擇目標', en: 'CHOOSE A TARGET' },
  'EXECUTANDO...': { zh: '執行中…', en: 'RUNNING...' },
  'Espionou': { zh: '偵查了', en: 'Spied on' },
  'Atacou': { zh: '攻擊了', en: 'Attacked' },
  'Foi atacado por': { zh: '被攻擊，來自', en: 'Was attacked by' },
  'custou': { zh: '花費', en: 'cost' },
  'Dano causado': { zh: '造成的傷害', en: 'Damage dealt' },
  'MISSÃO FRACASSADA. Sua equipe não obteve informações.': { zh: '任務失敗。你的團隊沒有取得任何情報。', en: 'MISSION FAILED. Your team got no information.' },
  'MISSÃO FRACASSADA. A operação não saiu como o planejado.': { zh: '任務失敗。行動沒有按計畫進行。', en: 'MISSION FAILED. The operation did not go as planned.' },
  'Sem operações hoje': { zh: '今天沒有行動', en: 'No operations today' },
  'EU FIZ': { zh: '我出手', en: 'I DID' },
  'EU SOFRI': { zh: '我被打', en: 'I TOOK' },
  // Missões, sequência e dossiê
  'Zera à meia-noite · até': { zh: '午夜重置 · 每天最多', en: 'Resets at midnight · up to' },
  'Black Coins por dia': { zh: 'Black Coins／天', en: 'Black Coins per day' },
  'Bater o ponto': { zh: '打卡上班', en: 'Clock in' },
  'Entrar no jogo hoje': { zh: '今天登入遊戲', en: 'Log into the game today' },
  'Furar o chão': { zh: '鑽穿地層', en: 'Drill the ground' },
  'Encher barris': { zh: '裝滿油桶', en: 'Fill barrels' },
  'Fechar negócio': { zh: '成交生意', en: 'Close a deal' },
  'Encher o tanque': { zh: '加滿油箱', en: 'Fill the tank' },
  'PEGAR +': { zh: '領取 +', en: 'CLAIM +' },
  'de': { zh: '／', en: 'of' },
  'dia': { zh: '天', en: 'day' },
  'dias': { zh: '天', en: 'days' },
  'seguido': { zh: '連續', en: 'in a row' },
  'seguidos': { zh: '連續', en: 'in a row' },
  'dias \u2192 +': { zh: '天 \u2192 +', en: 'days \u2192 +' },
  'ESPIONAGEM CONCLUÍDA! Relatório entregue.': { zh: '商業間諜完成！情報已送達。', en: 'ESPIONAGE DONE! Report delivered.' },
  'º no ranking': { zh: '名 · 排行榜', en: 'th in the ranking' },
  'pequena': { zh: '小型', en: 'small' },
  'boa': { zh: '不錯', en: 'good' },
  'monstruosa': { zh: '巨獸級', en: 'monstrous' },
  'LV': { zh: 'LV', en: 'LV' },
  // Lote final: auditoria estática + runtime
  'SABOTAGEM SILENCIOSA': { zh: '無聲破壞', en: 'SILENT SABOTAGE' },
  'GOLPE DE COLARINHO BRANCO': { zh: '白領黑手', en: 'WHITE-COLLAR HEIST' },
  'Uma válvula "esquecida" aberta na madrugada. O oleoduto do alvo sangra petróleo no mangue a noite inteira e a produção dele vira prejuízo puro.': { zh: '深夜裡一個「忘記」關上的閥門。目標的油管整夜把石油漏進紅樹林，他的產量全變成純虧損。', en: 'A valve "forgotten" open at dawn. The target pipeline bleeds oil into the swamp all night and his output turns into pure loss.' },
  'Um "acidente" na plataforma do alvo: cabo rompido, torre parada, jornalistas na área. Prejuízo grande e manchete no dia seguinte.': { zh: '目標的鑽油平台發生「意外」：鋼索斷裂、鑽塔停擺、記者全跑來。損失慘重，隔天還上頭條。', en: 'An "accident" on the target platform: snapped cable, rig stopped, reporters everywhere. Big losses and tomorrow headline.' },
  'Você paga corretores para despejar o barril do alvo no mercado paralelo. O preço afunda e o império dele perde uma fortuna sem ninguém encostar um dedo.': { zh: '你付錢讓經紀人把目標的油桶倒進黑市。價格崩跌，他的帝國損失一大筆，卻沒人動過一根手指。', en: 'You pay brokers to dump the target barrels on the grey market. The price sinks and his empire loses a fortune without anyone lifting a finger.' },
  'Tenta de novo em instantes.': { zh: '請稍後再試一次。', en: 'Try again in a moment.' },
  'Tenta de novo mais tarde.': { zh: '請稍後再試一次。', en: 'Try again later.' },
  'do seu saldo.': { zh: '（從你的餘額扣除）。', en: 'from your balance.' },
  'Teto de respeito atingido': { zh: '已達聲望上限', en: 'Respect cap reached' },
  'Contando as moedas do cofre…': { zh: '正在清點金庫裡的金幣…', en: 'Counting the coins in the vault…' },
  'Chamando os capangas para a mesa…': { zh: '正在召集手下上桌…', en: 'Calling the crew to the table…' },
  'Afinando a orquestra do cassino…': { zh: '正在調校賭場的樂隊…', en: 'Tuning the casino orchestra…' },
  'Preparando os cartazes dos procurados…': { zh: '正在張貼通緝海報…', en: 'Printing the wanted posters…' },
  'LISTA DOS MAIS PROCURADOS': { zh: '頭號通緝名單', en: 'MOST WANTED LIST' },
  'Imune — acabou de tomar um golpe': { zh: '免疫中 — 他剛剛才被打過', en: 'Immune — was just hit' },
  '— e é': { zh: '— 而且會', en: '— and it is' },
  'Regras do ranking': { zh: '排行榜規則', en: 'Ranking rules' },
  'RANKING DOS MAGNATAS': { zh: '石油大亨排行榜', en: 'TYCOONS RANKING' },
  'RANKING DOS CORRETORES': { zh: '業務員排行榜', en: 'BROKERS RANKING' },
  '. É o FOX Dólar que define o Ranking dos Magnatas e o Jackpot! 👑': { zh: '。FOX Dólar 決定石油大亨排行榜和累積獎池！👑', en: '. FOX Dólar decides the Tycoons Ranking and the Jackpot! 👑' },
  'Limite de escudos atingido.': { zh: '已達護盾數量上限。', en: 'Shield limit reached.' },
  'Integridade LV.': { zh: '完整度 LV.', en: 'Integrity LV.' },
  'Usina LV.': { zh: '鑽油塔 LV.', en: 'Rig LV.' },
  'Envasadora LV.': { zh: '裝桶廠 LV.', en: 'Bottling plant LV.' },
  'CUSTO DE': { zh: '成本 ·', en: 'COST OF' },
  'consome': { zh: '會消耗', en: 'consumes' },
  'Coletar': { zh: '收取', en: 'Collect' },
  'Continuar': { zh: '繼續', en: 'Continue' },
  'Última extração: +': { zh: '上次開採：+', en: 'Last extraction: +' },
  'gotas': { zh: '油滴', en: 'drops' },
  'gotas insuficientes': { zh: '油滴不足', en: 'not enough drops' },
  'fora de operação': { zh: '停止運作', en: 'out of operation' },
  'Envasado e lacrado': { zh: '已裝桶並封蓋', en: 'Bottled and sealed' },
  'ENVASE': { zh: '裝桶', en: 'BOTTLING' },
  'barril': { zh: '桶', en: 'barrel' },
  'barris': { zh: '桶', en: 'barrels' },
  'Vale': { zh: '價值', en: 'Worth' },
  'FOX Dólar quando vendido na Bolsa': { zh: 'FOX Dólar（在石油交易所賣出時）', en: 'FOX Dólar when sold on the Exchange' },
  'a': { zh: '', en: 'the' },
  'º': { zh: '', en: '' },
};
